<template>
  <div class="py-4">
    Basic Info
  </div>
</template>

<script>
export default {

}
</script>

<style>

</style>